<template>
    <div class="news-single">
        <h1>{{ metaData.header }}</h1>
    </div>
</template>

<script>
    export default {
        name: "NewsSingle",
        props: ['alias'],
        data() {
            return {
                metaUrl: '/news/' + window.location.pathname.split('/').reverse()[0]
            }
        }
    }
</script>

<style scoped>

</style>
